// Admiral Adblock Targeting
// https://docs.getadmiral.com/docs/js-api-examples#set-targeting-kvps-asynchronously

const Init = (isSignedIn, isSubscribed, subscriptionLevel) => {
    window.admiral = window.admiral || function() {(admiral.q = admiral.q || []).push(arguments)};
    window.admiral("targeting", "pause");

    window.admiral("targeting", "set", "isSignedIn", isSignedIn);
    window.admiral("targeting", "set", "isSubscribed", isSubscribed);
    window.admiral("targeting", "set", "subscriptionLevel", subscriptionLevel);

    window.admiral("targeting", "ready");
}

export default {
    Init,
}